import { WSButton } from "@wingspanhq/fe-component-library";

import {
  DataSourceType,
  RequirementType
} from "@wingspanhq/payments/dist/interfaces";
import { useHistory } from "react-router-dom";
import { useFeatureFlags } from "../../../../../query/hooks/useFeatureFlags";
import { addIndefiniteArticleToWord } from "../../../../../shared/utils/addIndefiniteArticleToWord";
import { useGoToBulkReviewRequirements } from "../../../../BulkReview/paths";
import { PayeeFilterRequirementStatus } from "../../../../Payees/routes/RoutePayees/filters/types";
import { getRequirementDefinitionName } from "../../../../RequirementDefinitions/utils";
import { useGoToDashboardPayeeRequirementDetails } from "../../../routes/RouteRequirementDetails/RoutePayeeRequirementDetails";
import { NotificationTemplate } from "../index";

export type RequirementToApproveContext = {
  title: string;
  payerPayeeId: string;
  requirementReviewId: string;
  payee: {
    payeeId: string;
    payeeName: string;
  };
  requirement: {
    requirementId: string;
    requirementDefinitionId: string;
    requirementType: RequirementType;
    status: string;
    payerPayeeEngagementIds: string;
    dataSourceId: string;
    dataSourceType: DataSourceType;
  };
};

const GROUP_THRESHOLD = 2;

export const RequirementPendingReviewClient: NotificationTemplate<RequirementToApproveContext> =
  {
    renderTitle: props =>
      props.group.length >= GROUP_THRESHOLD
        ? "Multiple reviews required"
        : "Review is required",
    renderBody: props => (
      <>
        {props.group.length >= GROUP_THRESHOLD ? (
          `${props.group.length} contractor requirements require your approval.`
        ) : (
          <>
            The contractor submitted{" "}
            {addIndefiniteArticleToWord(
              getRequirementDefinitionName({
                type: props.context.requirement.requirementType,
                // TODO(ivanh): add context and policy type here
                ...(props.context.requirement as any).dataSourceMetadata
              })
            )}{" "}
            requirement for your approval. Review the submission and take
            action.
          </>
        )}
      </>
    ),
    Footer: props => {
      const history = useHistory();

      const goToPayeeRequirementDetails =
        useGoToDashboardPayeeRequirementDetails();
      const goToBulkReviewRequirements = useGoToBulkReviewRequirements();

      const queryFeatureFlags = useFeatureFlags();

      if (props.group.length >= GROUP_THRESHOLD) {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onClick={() => {
              if (queryFeatureFlags.data?.requirementsBulkReview) {
                goToBulkReviewRequirements({
                  filter: {
                    status: PayeeFilterRequirementStatus.PendingApproval
                  }
                });
                return;
              }

              history.push("/member/dashboard/client-pending-review");
            }}
          >
            View requirements
          </WSButton.Link>
        );
      } else {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onClick={() => {
              goToPayeeRequirementDetails({
                requirementId: props?.context?.requirement?.requirementId,
                payeeId: props?.context?.payee?.payeeId
              });
            }}
          >
            View requirement
          </WSButton.Link>
        );
      }
    }
  };
